import {
  AdditionalOption,
  BasicOption,
  OldAdditionalOption,
  useOptionMap,
} from '@/entities/room'
import { cn } from '@/shared/lib'

import { Label } from '../../common'

type OptionListProps = {
  options: (AdditionalOption | OldAdditionalOption | BasicOption)[]
  disabled?: boolean
  className?: string
}

export const OptionList = ({
  options,
  disabled,
  className,
}: OptionListProps) => {
  const { OPTION_MAP } = useOptionMap()

  return (
    <ul
      className={cn(
        'typo-body2 font-medium text-black',
        'flex flex-wrap gap-x-12.5 gap-y-1',
        className,
      )}
    >
      {options.map(option => (
        <li key={option} className="py-2.5">
          <Label
            size="small"
            icon={OPTION_MAP[option].icon}
            {...(disabled && {
              iconClassName: 'text-gray-300',
              className: 'text-gray-300 line-through',
            })}
          >
            {OPTION_MAP[option].label}
          </Label>
        </li>
      ))}
    </ul>
  )
}
